// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
.spot-wrapper {
  position: relative;
}
.spot-wrapper > img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.spot-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px 30px;
  color: white;
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
.spot-content.no-text-cta {
  padding: 0;
}
.spot-content.no-text-cta .btn {
  height: 100%;
  width: 100%;
  opacity: 0;
}
.spot-content a {
  color: white;
  background: rgba(0, 0, 0, 0.2392156863);
}
.spot-content h2 {
  font-family: "PT Serif", serif;
  font-size: 2.1875rem;
}
.spot-content p {
  font-size: 1.125rem;
}
.spot-content .btn.transparent {
  border: 2px solid white;
}
.spot-content .btn.purple {
  background-color: #5c0a31;
  border-color: #5c0a31;
}
.spot-content .btn:hover {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/storyblok/components/storyblok-spots/storyblok-spot/storyblok-spot.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,kBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;AADF;AAGE;EACE,UAAA;AADJ;AAGI;EACE,YAAA;EACA,WAAA;EACA,UAAA;AADN;AAKE;EACE,YAAA;EACA,uCAAA;AAHJ;AAME;EACE,8BAAA;EACA,oBAAA;AAJJ;AAOE;EACE,mBAAA;AALJ;AAWI;EACE,uBAAA;AATN;AAYI;EACE,yBDtDW;ECuDX,qBDvDW;AC6CjB;AAaI;EACE,YAAA;AAXN","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n.spot-wrapper {\n  position: relative;\n\n  > img {\n    width: 100%;\n    height: auto;\n    object-fit: cover;\n  }\n}\n\n.spot-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 40px 30px;\n  color: white;\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  &.no-text-cta {\n    padding: 0;\n\n    .btn {\n      height: 100%;\n      width: 100%;\n      opacity: 0;\n    }\n  }\n\n  a {\n    color: white;\n    background: #0000003d;\n  }\n\n  h2 {\n    font-family: 'PT Serif', serif;\n    font-size: 2.1875rem;\n  }\n\n  p {\n    font-size: 1.125rem;\n  }\n\n\n  .btn {\n\n    &.transparent {\n      border: 2px solid white;\n    }\n\n    &.purple {\n      background-color: $wine-red-light;\n      border-color: $wine-red-light;\n    }\n\n    &:hover {\n      color: white;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
